"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isPlaceholderObject = exports.hasBackgroundColor = exports.getOriginalColorsMap = exports.getInitialMaxColorAmount = exports.getColorKeysForAggregatedColor = exports.getAggregatedColors = exports.getAggregatedColorCount = void 0;
var _Selectors = require("../DesignArea/Selectors");
var _styles = require("@material-ui/core/styles");
var _DesignDataService = require("../../Services/DesignDataService");
var _find = _interopRequireDefault(require("lodash/find"));
var _get = _interopRequireDefault(require("lodash/get"));
var _size = _interopRequireDefault(require("lodash/size"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var hasBackgroundColor = exports.hasBackgroundColor = function hasBackgroundColor(colors) {
  return colors.map(function (color) {
    return (0, _Selectors.isValidHex)(color.value) ? (0, _styles.hexToRgb)(color.value) : color.value || 'rgb(0, 0, 0)';
  }).map(_DesignDataService.getRgbValuesFromString).some(_DesignDataService.isColorTooBright);
};
var getAggregatedColors = exports.getAggregatedColors = function getAggregatedColors(colors) {
  return Object.keys(colors).reduce(function (uniqColors, colorKey) {
    var color = colors[colorKey];
    if ((0, _find["default"])(uniqColors, function (c) {
      return c.identifier === color.identifier;
    })) {
      return uniqColors;
    }
    return _objectSpread(_objectSpread({}, uniqColors), {}, _defineProperty({}, colorKey, color));
  }, {});
};
var getAggregatedColorCount = exports.getAggregatedColorCount = function getAggregatedColorCount(colors) {
  return (0, _size["default"])(getAggregatedColors(colors));
};
var getInitialMaxColorAmount = exports.getInitialMaxColorAmount = function getInitialMaxColorAmount(state) {
  return (0, _get["default"])(state, 'imageGallery.selectedImage.operations.vectorizeMaxColorAmount', undefined);
};
var getOriginalColorsMap = exports.getOriginalColorsMap = function getOriginalColorsMap(state) {
  return (0, _get["default"])(state, 'imageGallery.selectedImage.operations.vectorizeOriginalColorsMap', {});
};
var getColorKeysForAggregatedColor = exports.getColorKeysForAggregatedColor = function getColorKeysForAggregatedColor(vectorizeColorsMap, colorKey) {
  var colors = [];
  //loop over the elements and detect all colors with the same mapped value
  var colorToColorize = vectorizeColorsMap[colorKey];
  for (var _colorKey in vectorizeColorsMap) {
    if (!vectorizeColorsMap.hasOwnProperty(_colorKey)) {
      continue;
    }
    if (vectorizeColorsMap[_colorKey].identifier === colorToColorize.identifier) {
      colors.push(_colorKey);
    }
  }
  return colors;
};
var isPlaceholderObject = exports.isPlaceholderObject = function isPlaceholderObject(obj) {
  return obj.type === 'Text' && (0, _Selectors.isPlaceholderContent)(obj.content) || obj.type === 'Image' && obj.imageData.isPlaceHolderImage;
};